import React from "react";
import Marquee from "react-fast-marquee";
import { SELECTED_WORK } from "../../data/content";

export const SelectedWork = () => (
  <section id="work" className="relative border-y border-border bg-[#0b0b0b]" data-testid="work">
    <div className="flex flex-col sm:flex-row items-stretch overflow-hidden">
      <span className="flex items-center justify-center sm:justify-start border-b sm:border-b-0 sm:border-r border-border px-4 md:px-8 py-3 sm:py-6 md:py-8 font-mono-c text-[9px] md:text-xs tracking-[0.22em] uppercase text-muted-foreground whitespace-nowrap bg-[#080808]">
        Selected Work
      </span>
      <div className="flex-1 flex items-center min-w-0 py-3 sm:py-0">
        <Marquee speed={45} gradient={false} autoFill>
          {SELECTED_WORK.map((w, i) => (
            <span key={i} className="flex items-center" data-testid={`selected-work-${i}`}>
              <span className="font-display uppercase text-xl sm:text-2xl md:text-4xl tracking-tight px-4 sm:px-6 md:px-8 text-foreground/85 hover:text-[hsl(var(--accent))] transition-colors">
                {w}
              </span>
              <span className="text-[hsl(var(--accent))] text-base md:text-lg">/</span>
            </span>
          ))}
        </Marquee>
      </div>
    </div>
  </section>
);
